<template>
    <b-card no-body class="m-0 px-0">
        <v-table ref="history-table" name="commission-upload-history" :items-provider="itemsProvider" :fields="fields" :buttons="buttons" search>
            <template #filters>
                <div class="row">
                    <div class="col-md-6">
                        <label>Durum</label>
                        <v-select
                            v-model="filters.status"
                            :options="filterData.statuses"
                            label="text"
                            :reduce="(item) => item.value"
                            placeholder="Tümü"
                            clearable
                            v-on:input="$refs['history-table'].refresh()"
                        />
                    </div>
                    <div class="col-md-6">
                        <label>Kullanıcı</label>
                        <v-select
                            v-model="filters.userId"
                            :options="filterData.users"
                            label="text"
                            :reduce="(item) => item.value"
                            placeholder="Tümü"
                            clearable
                            v-on:input="$refs['history-table'].refresh()"
                        />
                    </div>
                </div>
                <div class="row mt-1 mb-50">
                    <div class="col-md-3">
                        <label>Başlangıç Tarihi</label>
                        <v-date-picker v-model="filters.startDate" placeholder="Başlangıç Tarihi" clearable v-on:input="$refs['history-table'].refresh()" />
                    </div>
                    <div class="col-md-3">
                        <label>Bitiş Tarihi</label>
                        <v-date-picker v-model="filters.endDate" placeholder="Bitiş Tarihi" clearable v-on:input="$refs['history-table'].refresh()" />
                    </div>
                    <div class="col-md-6 d-flex align-items-end justify-content-end">
                        <button class="btn btn-primary" v-on:click="clearFilters">Temizle</button>
                    </div>
                </div>
            </template>
        </v-table>
        <b-modal v-model="showDetailModal" size="lg" title="İşlem Detayı">
            <commission-upload-detail v-if="selectedMasterId" :master-id="selectedMasterId" />
            <template #modal-footer><div></div></template>
        </b-modal>
    </b-card>
</template>

<script>
import VaultOperationsApi from "@/api/vault-operations";
import CommissionUploadDetail from "./CommissionUploadDetail.vue";
import moment from "moment";
import { BCard } from "bootstrap-vue";
import UserApi from "@/api/user";

export default {
    components: {
        BCard,
        CommissionUploadDetail,
    },
    data() {
        return {
            showDetailModal: false,
            selectedMasterId: null,
            filters: {
                status: null,
                userId: null,
                startDate: null,
                endDate: null,
            },
            filterData: {
                users: [],
                statuses: [
                    { text: "Beklemede", value: 0 },
                    { text: "İşleniyor", value: 1 },
                    { text: "Başarılı", value: 2 },
                    { text: "Hatalı", value: 3 },
                    { text: "İptal Edildi", value: 4 },
                ],
            },
            fields: [
                { name: "Oluşturma Zamanı", key: "CreateTimeStr", thClass: "text-nowrap" },
                { name: "Oluşturan", key: "UserName", thClass: "text-nowrap" },
                { name: "Durum", key: "StatusTr", thClass: "text-nowrap" },

                {
                    name: "İşlem İlerlemesi",
                    key: "progress",
                    thClass: "w-25",
                    component: true,
                    componentOptions: { name: "vault-operations/CommissionStatusProgress" },
                },
            ],
            buttons: [{ text: "Detay", key: "detail", icon: "SearchIcon", variant: "primary", action: this.showDetails }],
        };
    },
    created() {
        this.fetchUsersForFilter();
    },
    methods: {
        fetchUsersForFilter() {
            UserApi.EmployeeListUser().then((res) => {
                if (res.data.Success) {
                    this.filterData.users = res.data.Data.map((user) => ({
                        text: user.EmployeeFullName,
                        value: user.Id,
                    }));
                }
            });
        },
        clearFilters() {
            this.filters = {
                status: null,
                userId: null,
                startDate: null,
                endDate: null,
            };
            this.$nextTick(() => {
                this.$refs["history-table"].refresh();
            });
        },
        itemsProvider() {
            return new Promise((resolve, reject) => {
                VaultOperationsApi.Vault.GetTransactionBatchList(this.filters)
                    .then((res) => {
                        if (res.data.Success) {
                            let data = res.data.Data || [];
                            const statusMap = {
                                Pending: "Beklemede",
                                InProgress: "İşleniyor",
                                Success: "Başarılı",
                                Failed: "Hatalı",
                                Cancelled: "İptal Edildi",
                            };
                            data.forEach((item) => {
                                item.CreateTimeStr = moment(item.CreateTime).format("DD.MM.YYYY HH:mm");
                                item.StatusTr = statusMap[item.Status] || item.Status;
                            });
                            resolve({ data: { Data: data } });
                        } else {
                            this.$result(res);
                            reject(res.data.Message || "Bir hata oluştu");
                        }
                    })
                    .catch((err) => {
                        this.$result(null, err);
                        reject(err);
                    });
            });
        },
        editor(response) {
            let data = response.Data || [];
            data.forEach((item) => {
                item.CreateTimeStr = this.$options.filters.datetime(item.CreateTime);
            });
            return data;
        },
        showDetails(item) {
            this.selectedMasterId = item.Id;
            this.showDetailModal = true;
        },
    },
};
</script>
